export default "__VITE_ASSET__DJNKTmSO__"